{
  "alert": "Opozorilo",
  "dismiss": "Opusti"
}
